
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-52c08b8d&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./purchaseButton.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./purchaseButton.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-52c08b8d!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./purchaseButton.vue"),
  /* scopeId */
  "data-v-52c08b8d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/purchaseButton.vue
// module id = 40
// module chunks = 1